"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEnumToFeatureName = exports.NetworkFeature = exports.UserTokenExpiry = void 0;
const solanaBorsh_1 = require("./solanaBorsh");
class UserTokenExpiry extends solanaBorsh_1.Assignable {
}
exports.UserTokenExpiry = UserTokenExpiry;
class NetworkFeature extends solanaBorsh_1.Enum {
}
exports.NetworkFeature = NetworkFeature;
solanaBorsh_1.SCHEMA.set(NetworkFeature, {
    kind: "enum",
    field: "enum",
    values: [["userTokenExpiry", UserTokenExpiry]],
});
solanaBorsh_1.SCHEMA.set(UserTokenExpiry, { kind: "struct", fields: [] });
const mapEnumToFeatureName = (enumValue) => {
    if (enumValue === "userTokenExpiry") {
        return "expire";
    }
    return enumValue;
};
exports.mapEnumToFeatureName = mapEnumToFeatureName;
//# sourceMappingURL=GatewayNetworkData.js.map